import * as React from 'react';
import RightOutlined from '@ant-design/icons/RightOutlined';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import LeftOutlined from '@ant-design/icons/LeftOutlined';
const defaultLoadingIcon = React.createElement(LoadingOutlined, { spin: true });
const defaultExpandIcon = React.createElement(RightOutlined, null);
const defaultRtlExpandIcon = React.createElement(LeftOutlined, null);
export default function useIcons({ contextExpandIcon, contextLoadingIcon, expandIcon, loadingIcon, isRtl, }) {
    return React.useMemo(() => ({
        expandIcon: expandIcon ?? contextExpandIcon ?? (isRtl ? defaultRtlExpandIcon : defaultExpandIcon),
        loadingIcon: loadingIcon ?? contextLoadingIcon ?? defaultLoadingIcon,
    }), [contextExpandIcon, contextLoadingIcon, expandIcon, isRtl, loadingIcon]);
}
